import {
    Box,
    CardMedia,
    Paper,
    Typography
  } from '@mui/material';
  import Cookies from 'js-cookie';
  import React from 'react';
  import { useTranslation } from 'react-i18next';
  import { convertCurrency } from '../../../utils/convertCurrency';
  import { useSelector } from 'react-redux';
  
  export default function AboutResource({ data }) {
    const { currency } = useSelector(state => state.currency);
    const { t } = useTranslation();
    const lang = Cookies.get("i18next") || "en";
  
    const [convertedAmount, setConvertedAmount] = React.useState(null);
    React.useEffect(() => {
      async function fetchConvertedAmount() {
        const result = await convertCurrency(data.price, data.currency, currency);
        setConvertedAmount(result);
      }
  
      fetchConvertedAmount();
    }, [data.price, currency, data.currency]);
  
    const rows = [
      { label: t("level"), value: lang === "ar" ? data?.level?.titleAR : data?.level?.titleEN },
      { label: t("classes"), value: lang === "ar" ? data?.classId?.titleAR : data?.classId?.titleEN },
      { label: t("studyCurriculum"), value: lang === "ar" ? data?.curriculums?.titleAR : data?.curriculums?.titleEN },
      { label: t("semester"), value: t(data?.semester) },
      { label: t("subject"), value: lang === "ar" ? data?.subject?.titleAR : data?.subject?.titleEN },
      { label: t("price"), value: `${convertedAmount !== null ? convertedAmount : "Loading..."} ${t(currency)}` },
    ];
  
    return (
      <Paper sx={{ padding: "32px 24px", marginY: "30px" }}>
        <CardMedia
          component="img"
          height="140"
          image={data.image ? `${process.env.REACT_APP_API_KEY}images/${data.image}` : "/logo.png"}
          alt="package img"
          sx={{ filter: "brightness(50%)", height: "400px" }}
        />
        <Typography
          variant="h4"
          sx={{ marginBottom: "20px", marginTop: "8px", fontWeight: "700" }}
        >
          {t(data?.resource)}
        </Typography>
  
        {rows.map((row, index) => (
          <Box
            key={index}
            sx={{
              display: 'flex',
              flexDirection: { xs: 'column', sm: 'row' },
              justifyContent: 'space-between',
              alignItems: 'center',
              gap: 2,
              marginBottom: "8px",
            }}
          >
            <Typography
              variant="body1"
              sx={{
                fontWeight: "700",
                background: "#f2f3f4",
                borderRadius: "1rem",
                padding: "1rem",
                flex: 1,
                textAlign: "center"
              }}
            >
              {row.label}
            </Typography>
            <Typography
              variant="body1"
              sx={{
                fontWeight: "400",
                background: "#f2f3f4",
                borderRadius: "1rem",
                padding: "1rem",
                flex: 1,
                textAlign: "center",
                color: "#5dade2"
              }}
            >
              {row.value}
            </Typography>
          </Box>
        ))}
      </Paper>
    );
  }
  